import A from '@/assets/image/A.png'
import B from '@/assets/image/B.png'
import C from '@/assets/image/C.png'
import D from '@/assets/image/D.png'
import E from '@/assets/image/E.png'
import F from '@/assets/image/F.png'
import G from '@/assets/image/G.png'
import checkbox from '@/assets/image/checkbox.png'
import radio from '@/assets/image/radio.png'
import select_succ from '@/assets/image/success.png'
import select_error from '@/assets/image/error.png'
import success from '@/assets/image/select_succ.png'
import error from '@/assets/image/select_error.png'

// 考试类型
// const examTypeLists = [
//     [1, '']
// ]

// 帮助类型链接
const examTypeUrl = new Map([
    [1, 'https://isharedev.map.qq.com/helper/circumstances.html'],
    [2, 'https://isharedev.map.qq.com/helper/coordinateTask.html'],
    [3, 'https://isharedev.map.qq.com/helper/poiCollectionOperationInner.html'],
    [4, 'https://isharedev.map.qq.com/helper/saojiePhoto.html'],
    [5, 'https://isharedev.map.qq.com/helper/RealTimeBus.html'],
    [6, 'https://isharedev.map.qq.com/helper/shotSpecification.html'],
    [7, 'https://isharedev.map.qq.com/helper/roadnametask.html'],
    [8, 'https://isharedev.map.qq.com/helper/instructions.html'],
    [9, 'https://isharedev.map.qq.com/helper/thegatetask.html'],
    [10, 'https://isharedev.map.qq.com/helper/SubwayEntrance.html'],
    [30, 'https://isharedev.map.qq.com/helper/roadUpdate/operationGuide.html'],
    [31, 'https://isharedev.map.qq.com/helper/roadUpdate/operationGuide.html'],
    [32, 'https://isharedev.map.qq.com/helper/roadUpdate/operationGuide.html'],
])

const taskTypeListMap = new Map([
    [1, '散点过期任务'],
    [2, '散点坐标任务'],
    [3, '引导点任务'],
    [4, '扫街任务'],
    [5, '公交站点任务'],
    [6, '室内任务'],
    [7, '道路名任务'],
    [8, '地铁站点任务'],
    [9, '大门任务'],
    [10, '地铁出入口'],
    [11, '交限任务'],
    [12, '公交线路任务'],
    [30, '道路大批任务'],
    [31, '道路新增任务'],
    [32, '道路评测任务'],
])

export{
    A,
    B,
    C,
    D,
    E,
    F,
    G,
    checkbox,
    radio,
    success,
    error,
    select_succ,
    select_error,
    examTypeUrl,
    taskTypeListMap
}